import { useQuery } from '@tanstack/react-query';
import { GET, GET_STOCK_CLAIM_REPORT } from '../../../../services';

export const STOCK_REPORT_ERROR_MESSAGE = 'ระบบสต็อกไม่พร้อมใช้งาน ลองใหม่ภายหลัง';

/**
 * ดึงรายงาน stock เคลมครั้งเดียวตอนเปิดหน้า (หรือกดรีเฟรช) แล้วกรอง/สรุปฝั่ง client ทั้งหมด
 * ไม่ส่ง error ต่อให้ modal กลางจอ เพราะหน้านี้ต้องโชว์ข้อความ error ของตัวเองในหน้า
 */
export const useGetStockClaimReport = () => {
  const { data, isFetching, isError, refetch } = useQuery({
    queryKey: ['stockClaimReport'],
    queryFn: async () => {
      try {
        const response = await GET(GET_STOCK_CLAIM_REPORT());
        return response?.result?.items ?? [];
      } catch (error) {
        throw { ...error, message: STOCK_REPORT_ERROR_MESSAGE, disabledThrow: true };
      }
    },
  });

  return {
    items: data ?? [],
    loading: isFetching,
    isError,
    errorMessage: isError ? STOCK_REPORT_ERROR_MESSAGE : '',
    onRefresh: refetch,
  };
};
